import { BASE_URL , LOGIN} from '../resources/APIEndpoints';
import axios from 'axios';

function AuthService() {
    this.login = (body) => axios.post(BASE_URL + LOGIN, body);
}

export default new AuthService();
